export default "__VITE_ASSET__C1fHzN5c__"